/** Thrown when a part's signature outlived its expiry - recoverable by signing the batch again. */
export class ExpiredSignatureError extends Error {}

/** Thrown when the API has already given up on the upload, which no amount of retrying will fix. */
export class MultipartUploadExpiredError extends Error {
  constructor() {
    super('This upload timed out and was cancelled by the server. Please try uploading again.');
  }
}

/**
 * Thrown when a part's request dies at the network layer instead of being answered by S3 - the
 * machine slept and Chrome killed the request with ERR_NETWORK_IO_SUSPENDED, wifi dropped, or the
 * socket went silent and hit the stall timeout.
 *
 * Distinct from a plain Error because the response is different: wait for the connection to come
 * back and pick up where we left off, rather than spending one of the part's retries immediately
 * and tearing the whole upload down.
 */
export class NetworkInterruptedError extends Error {}

/**
 * Thrown when the connection never came back within MAX_STALLED_MS. The multipart upload is
 * deliberately left intact server side - every part already in S3 is still valid - so this is
 * recoverable rather than fatal.
 */
export class MultipartUploadInterruptedError extends Error {
  constructor(cause: unknown) {
    super('Lost connection while uploading. Please check your network and try again.', { cause });
  }
}
